module.exports = {"SUBMISSION_API":"https://5dum6c4ytb.execute-api.us-east-1.amazonaws.com/dev/submission"}


//////////////////
// WEBPACK FOOTER
// ./src/experiment-designer/src/config.json
// module id = 1549
// module chunks = 0